<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('语言')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
    </van-nav-bar>
    <div class="main-content">
      <div v-for="(item, index) in langList" :key="index" class="item" @click="handleSetLang(item.key, index)">
        <div class="content">
          <img :src="item.icon" alt="" class="nation"/>
          <div class="title">{{ item.title }}</div>
        </div>
        <img src="@/assets/image/check.png" v-if="item.key === $i18n.locale" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  data() {
    return {
      langList: [
        {
          title: "English",
          key: "en",
          icon: require("@/assets/image/language/en.png"),
        },
        {
          title: "Deutsch",
          key: "de",
          icon: require("@/assets/image/language/de.png"),
        },
        // {
        //   title: "français",
        //   key: "fr",
        //   icon: require("@/assets/image/language/fr.png"),
        // },
        // {
        //   title: "Русский",
        //   key: "ru",
        //   icon: require("@/assets/image/language/ru.png"),
        // },
        // {
        //   title: "Español",
        //   key: "es",
        //   icon: require("@/assets/image/language/es.png"),
        // },
        // {
        //   title: "Melayu",
        //   key: "ms",
        //   icon: require("@/assets/image/language/ms.png"),
        // },
        // {
        //   title: "繁體中文",
        //   key: "tw",
        //   icon: require("@/assets/image/language/tw.png"),
        // },
        {
          title: "简体中文",
          key: "cn",
          icon: require("@/assets/image/language/cn.png"),
        },
        // {
        //   title: "Türkçe",
        //   key: "tr",
        //   icon: require("@/assets/image/language/tr.png"),
        // },
        {
          title: "日本語",
          key: "ja",
          icon: require("@/assets/image/language/ja.png"),
        },
        {
          title: "한국어",
          key: "ko",
          icon: require("@/assets/image/language/ko.png"),
        },
        // {
        //   title: "ภาษาไทย",
        //   key: "th",
        //   icon: require("@/assets/image/language/th.png"),
        // },
        // {
        //   title: "Filipino",
        //   key: "ph",
        //   icon: require("@/assets/image/language/ph.png"),
        // },
        {
          title: "Tiếng Việt",
          key: "vi",
          icon: require("@/assets/image/language/vi.png"),
        },
        // {
        //   title: "हिंदी",
        //   key: "hi",
        //   icon: require("@/assets/image/language/hi.png"),
        // },
        // {
        //   title: "bahasa Indonesia",
        //   key: "id",
        //   icon: require("@/assets/image/language/id.png"),
        // },
      ],

    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
  },
  methods: {
    ...mapMutations(["setLanguage"]),
    handleSetLang(lang) {
      this.$i18n.locale = lang;
      this.setLanguage(lang);
      localStorage.setItem('firstLoad', 'false')
    }
  },
  created() {
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.main-content {
  > .item {
    box-sizing: border-box;
    width: 100%;
    height: 100px;
    padding: 0 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }

    > .content {
      display: flex;

      > .nation {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        box-shadow: 0 0 1px rgba(0, 0, 0, .5);
      }

      > .title {
        line-height: 60px;
        font-size: 23px;
        color: #333;
        margin-left: 11px;
      }
    }
  }
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  .main-content {
    > .item {
      height: 57px; /* 100px * 0.5733 ≈ 57px */
      padding: 0 20px; /* 35px * 0.5733 ≈ 20px */

      > .content {
        > .nation {
          width: 34px; /* 60px * 0.5733 ≈ 34px */
          height: 34px; /* 60px * 0.5733 ≈ 34px */
        }

        > .title {
          line-height: 34px; /* 60px * 0.5733 ≈ 34px */
          font-size: 13px; /* 23px * 0.5733 ≈ 13px */
          margin-left: 6px; /* 11px * 0.5733 ≈ 6px */
        }
      }
    }
  }
  
  // 导航栏PC端适配
  ::v-deep .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }
  
  ::v-deep .van-nav-bar {
    height: 57px !important;
    line-height: 57px !important;
  }
  
  ::v-deep .van-nav-bar__content {
    height: 57px !important;
  }
  
  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
  }
  
  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }
}
</style>
